export default "__VITE_ASSET__a94ecc01__"